<template>
    <footer class="content-footer footer bg-footer-theme">
        <div class="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
            <div class="mb-2 mb-md-0">
                &copy; 2025 <a href="https://www.safeworkpro.com.au/" target="_blank" class="footer-link fw-bolder">SafeWorkPro Pty Ltd</a>. All rights reserved.
            </div>

        </div>
    </footer>
    
</template>

<script>
    export default {
        name: 'Footer',
    };
</script>

<style scoped>

</style>